<!-- Note:  this component presently operates in one of two modes:

                1. Read only (not edit mode); and
                2. Edit mode.

    Note:  if this component develops into something more complex,
           it will probably be broken into two component classes.
-->
<ng-container *ngIf="!this.EditMode">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>Site Milestones</mat-card-title>
            <div>
                <mat-icon svgIcon="bootstrap-flag"
                          title="Manage Milestones"
                          aria-label="Manage Milestones"
                          (click)="this.doOnEditMilestones($event)" 
                          (keyup.enter)="this.doOnEditMilestones($event)"></mat-icon>
            </div>
        </mat-card-header>

        <mat-card-content>
            <div *ngIf="(this.Milestones == null)">Loading Milestones ...</div>

            <div *ngFor="let milestone of this.Milestones">
                {{milestone.name}}
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>

<ng-container *ngIf="this.EditMode">
    <div *ngIf="(this.Milestones == null)">Loading Milestones ...</div>

    <div *ngFor="let milestone of this.Milestones"
         class="edit-mode-milestone-div">
        <span class="milestone-name-span">{{milestone.name}}</span>
        <span>{{milestone.Description}}</span>
        <div class="edit-mode-spacer"></div>

        <mat-icon (click)="this.openSiteMilestoneDialogue(milestone)"
                  (keyup.enter)="this.openSiteMilestoneDialogue(milestone)"
                  tabindex="0"
                  title="Edit Milestone"
                  class="edit-mode-mat-icon">edit</mat-icon>

        <mat-icon *ngIf="true"
                  (click)="this.deleteMilestone($event, milestone)"
                  (keyup.enter)="this.deleteMilestone($event, milestone)"
                  tabindex="1"
                  title="Delete Milestone">delete</mat-icon>

    </div>

    <button *ngIf="this.IsSiteLevelAccess"
            class="new-milestone-btn theme-primary-btn"
            mat-flat-button
            class="button-primary" 
            [disabled]="this.NewMilestoneButtonDisabled"
            (click)="this.openSiteMilestoneDialogue(null)">New Milestone</button>
</ng-container>

